module.exports = __webpack_public_path__ + "f40c31be58cc85c4aeb8e03a72acdd8a.jpg";